
export default {
	name: 'AboutPage',
	data () {
		return {
			baseURL: process.env.NUXT_APP_PANEL_BASE_URL,
		};
	},
	computed: {
		reasons ()
		{
			return [
				{ icon: 'https://cdn.enifex.com/images/featured_img1.svg', title: '24/7 Customer Support', desc: 'If you need help, our friendly customer service representative will be available for your queries 24/7.' },
				{ icon: 'https://cdn.enifex.com/images/featured_img2.svg', title: 'Multi-Chain',           desc: 'Offering you a multitude of assets on various networks.' },
				{ icon: 'https://cdn.enifex.com/images/featured_img3.svg', title: 'Security',              desc: 'Enifex provides strict sign-in protocols and protective measures to ensure the safety of traders.' },
			];
		},
	},
	methods: {
		isLogin ()
		{
			return (typeof window == 'undefined' ? false : !!window.localStorage.getItem('Enifex.AccessToken'));
		},
	},
}
